import { FiTool } from "react-icons/fi";

/**
 * Placeholder honesto para relatórios ainda não implementados.
 * Não busca dado nenhum e não inventa número — só avisa que a
 * funcionalidade está no roadmap. Ver CLAUDE.md: "não invente número em tela".
 */
const RelatorioEmDesenvolvimento = ({ titulo, descricao }) => (
  <div className="min-h-screen bg-gray-50 p-4 md:p-8">
    <div className="max-w-3xl mx-auto">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-10 text-center">
        <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center">
          <FiTool size={28} className="text-amber-500" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">{titulo}</h2>
        <p className="text-gray-500 mb-1">
          Este relatório ainda não foi implementado.
        </p>
        {descricao && (
          <p className="text-gray-400 text-sm max-w-md mx-auto">{descricao}</p>
        )}
        <span className="inline-block mt-5 text-xs font-semibold uppercase tracking-wide text-brand-green bg-brand-green bg-opacity-10 px-3 py-1 rounded-full">
          Em desenvolvimento
        </span>
      </div>
    </div>
  </div>
);

export default RelatorioEmDesenvolvimento;
